module.exports = __webpack_public_path__ + "img/ueno-main-top.48c32aca.png";